import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

export type StateSelectorParams = {
  sortByAttribute: string | null
  sortByMethod: string | null
  chartMethod: string | null
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const sortByAttribute = block?.get<string>('sortByAttribute') || null
  const sortByMethod = block?.get<string>('sortByMethod') || null
  const chartMethod = block?.get<string>('chartMethod') || null
  return {
    sortByAttribute,
    sortByMethod,
    chartMethod
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : prev.sortByAttribute !== next.sortByAttribute ||
      prev.sortByMethod !== next.sortByMethod ||
      prev.chartMethod !== next.chartMethod
